import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Analytics from "@/components/Analytics";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import HealthCheckPage from "@/pages/HealthCheckPage";
import ThankYouPage from "@/pages/ThankYouPage";
import PrivacyPage from "@/pages/PrivacyPage";
import PricingGuidePage from "@/pages/PricingGuidePage";
import ArticlesPage from "@/pages/ArticlesPage";
import ArticlePage from "@/pages/ArticlePage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/xero-health-check" element={<HealthCheckPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/pricing" element={<PricingGuidePage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:slug" element={<ArticlePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
